<template>
  <div class="layout">
    <!-- <p>test</p> -->
    <layout-header @alph="showAlphabet = !showAlphabet" :selLetter="selLetter" :cName="cName" @more="showMore"
      @refresh="compKey += 1" @showUser="showUser = !showUser" :class="{ blur: isBlur }"></layout-header>
    <sub-header class="pc" />
    <transition name="alphtrans">
      <alphabet-filter v-if="showAlphabet" :bid="bid" :cName="cName" :cid="cid" @close="showAlphabet = false" />
    </transition>
    <router-view @refresh="compKey += 1" class="main-content" :key="compKey" :class="{ blur: isBlur }"></router-view>
    <layout-footer v-if="!showCred" :class="{ blur: isBlur }" @refresh="compKey += 1"></layout-footer>
    <!-- <div v-if="true" class="userMenu pc">
      <ul>
        <a @click="showProfile"><li>Profile</li></a>
        <a @click="showCart"><li>Shopping Cart</li></a>
        <a @click="logout"><li>Logout</li></a>
      </ul>
    </div> -->
    <div v-if="showUMenu" class="userMenu mobile">
      <ul>
        <a href="/user">
          <li>Profile</li>
        </a>
        <a href="/shoppingCart">
          <li>Shopping Cart</li>
        </a>
        <a @click="logout">
          <li>Logout</li>
        </a>
      </ul>
    </div>
    <shopping-cart v-if="showSC" @close="close" />
    <user class="user" :class="{ useractive: showUser }" @menu="menuAction" @close="close" />
    <more-menu :bid="bid" v-if="isMore" @close="close" />
    <change-mail v-if="changeEmail" @close="close" />
    <change-password v-if="changePassword" @close="close" />
    <manage-address v-if="showAddress" @back="backAddress()" @close="close" />
    <credential v-if="showCred" />
  </div>
</template>

<script>
import Register from '@/components/Register'
import ForgotPassword from '@/components/ForgotPassword'
import LayoutHeader from './LayoutHeader'
import SubHeader from './SubHeader'
import LayoutFooter from './LayoutFooter'
import ShoppingCart from '@/components/ShoppingCart'
import User from '@/components/User'
import MoreMenu from '@/components/MoreMenu'
import AlphabetFilter from '@/components/AlphabetFilter'
import ChangeMail from '@/components/ChangeMail'
import ChangePassword from '@/components/ChangePassword'
import ManageAddress from '@/Components/ManageAddress.vue'
import Credential from '@/Components/Credential.vue'

export default {
  name: 'Layout',
  data() {
    return {
      isBlur: false,
      showUMenu: false,
      showSC: false,
      // showUser:false,
      compKey: 0,
      bid: null,
      filter: false,
      isMore: false,
      cName: null,
      selLetter: null,
      showAlphabet: false,
      changeEmail: false,
      changePassword: false,
      showAddress: false,
    };
  },
  computed: {
    showCred() {
      return this.$store.state.showCred
    },
    showUser() {
      return this.$store.state.editUser
    }
  },
  components: {
    ForgotPassword,
    LayoutHeader,
    SubHeader,
    LayoutFooter,
    Register,
    ShoppingCart,
    User,
    MoreMenu,
    AlphabetFilter,
    ChangeMail,
    ChangePassword,
    ManageAddress,
    Credential
  },
  methods: {
    menuFilter(bid, cid, name, letter) {
      this.bid = bid;
      let id1 = bid;
      let id2 = cid;
      if (id1 == -1) {
        id1 = null;
        this.bid = id1;
      }
      if (id2 == -1) {
        id2 = null;
      }

      this.cName = name;
      this.cid = cid;
      this.selLetter = letter;
      // if(id2){
      // } else{
      //   this.filter = false
      // }

      let currItem = localStorage.getItem('currItem');
      let currAlph = localStorage.getItem('currAlph');

      this.$router.push({ path: '/network', query: { bid: id1, cid: id2, letter: letter, item: currItem, alph: currAlph } });
      this.compKey++;
      console.log(this.bid);
    },
    menuAction(menu) {
      this.showUser = false;
      if (menu == 'cart') {
        this.showSC = true;
      } else if (menu == 'logout') {
        this.$store.commit('user/MU_Logout');
      } else if (menu == 'email') {
        this.changeEmail = true;
      } else if (menu == 'password') {
        this.changePassword = true;
      } else if (menu == 'address') {
        this.showAddress = true;
      }
    },
    backAddress() {
      this.showUser = true;
      this.showAddress = false;
    },
    showAlph() {
      console.log('layout showAlph triggered!');
      this.showAlphabet = true;
    },
    showMore() {
      this.isMore = true;
    },
    logout() {
      this.$store.commit('user/MU_Logout');
    },
    close() {
      this.isBlur = false;
      this.showSC = false;
      this.showUser = false;
      this.isMore = false;
      this.changeEmail = false;
      this.changePassword = false;
      this.showAddress = false;
    },
    showCart() {
      this.showSC = true;
      this.showUMenu = false;
      this.isBlur = true;
    },
    showProfile() {
      this.showUser = true;
      this.showUMenu = false;
    }
  },
  created() {
    localStorage.setItem('currItem', -1);
    localStorage.setItem('currAlph', '-');
  }
};
</script>

<style scoped>
.layout {
  position: relative;
}

/* .main-content{
  margin: 0 auto;
  min-width: 1170px;
  min-height: calc(100vh - 115px - 80px);
  padding-top: calc(115px + 40px);
  padding-bottom: 40px;
} */
.blur {
  filter: blur(10px);
  /* opacity: 0.5; */
}

.userMenu {
  position: fixed;
  top: 90px;
  right: 2%;
  background: #C4CCCE;
  border-radius: 8px;
  z-index: 101;
  overflow: hidden;
}

ul {
  list-style-type: none;
  padding: 0;
}

ul li {
  text-align: left;
  padding: 10px;
  /* background: #fff; */
  /* border-radius: 8px; */
  /* margin-right: 40px;
  margin-bottom: 5px; */
}

ul li:hover {
  background: #5f6769;
  /* opacity: 0.5; */
  color: #eee;
  cursor: pointer;
}

.pc {
  display: block;
}

.mobile {
  display: none;
}

a {
  color: #000;
  text-decoration: none;
}

.alphtrans-enter-active,
.alphtrans-enter-active {
  transition: opacity 0.1s ease-in-out, transform 0.2s ease-in-out;
}

.alphtrans-enter,
.alphtrans-leave-to {
  opacity: 0;
  transform: translateY(-100px);
}

.alphtrans-enter-to,
.alphtrans-leave {
  opacity: 1;
  transform: translateY(0px);
}

.user {
  opacity: 0;
  transform: translateY(-250px);
  transition: 0.3s ease-in-out;
}

.useractive {
  opacity: 1;
  transform: none;
  transition: 0.3s ease-in-out;
}

@media screen and (max-width: 900px) {
  .pc {
    display: none;
  }

  .mobile {
    display: block;
  }

  .main-content {
    min-width: 0;
    /* padding-top: calc(0px + 40px); */
    padding-top: calc(100px + 20px);
  }

  .user {
    opacity: 0;
    transform: translateY(-100%);
    transition: 0.3s ease-in-out;
  }

  .useractive {
    opacity: 1;
    transform: none;
    transition: 0.3s ease-in-out;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Layouts/Layout.vue